module.exports = __webpack_public_path__ + "static/ErhardtA-8c96fb071616e1ac33acb4b108655861.gif";